import React from 'react';

export type SegmentedToggleValue = 'create-new' | 'review-edit-existing';

type Props = {
	value: SegmentedToggleValue;
	onChange: (v: SegmentedToggleValue) => void;
	leftLabel?: string;
	rightLabel?: string;
	className?: string;
};

const SegmentedToggle: React.FC<Props> = ({
	value,
	onChange,
	leftLabel = 'Create New',
	rightLabel = 'Review / Edit Existing',
	className,
}) => {
	return (
		<div className={`inline-flex ${className ?? ''}`} role="group">
			<button
				type="button"
				onClick={() => onChange('create-new')}
				className={[
					'px-2 py-1 rounded-md border-2 flex-1 rounded-r-none font-semibold transition-colors duration-150',
					value === 'create-new'
						? 'border-[var(--color-as-orange-primary)] text-[var(--color-as-orange-primary)]'
						: 'border-[var(--color-as-dark-blue)] text-black',
					'hover:border-[var(--color-as-orange-primary)] cursor-pointer hover:text-[var(--color-as-orange-primary)]',
					value === 'create-new' ? 'company-hover-toggle-button-active' : '',
				].join(' ')}
			>
				{leftLabel}
			</button>
			<button
				type="button"
				onClick={() => onChange('review-edit-existing')}
				className={[
					'px-2 py-1 rounded-md border-2 rounded-l-none flex-1 font-semibold transition-colors duration-150',
					value === 'review-edit-existing'
						? 'border-[var(--color-as-orange-primary)] text-[var(--color-as-orange-primary)]'
						: 'border-[var(--color-as-dark-blue)]',
					'hover:border-[var(--color-as-orange-primary)] cursor-pointer hover:text-[var(--color-as-orange-primary)]',
					value === 'review-edit-existing' ? 'company-hover-toggle-button-active' : '',
				].join(' ')}
			>
				{rightLabel}
			</button>
		</div>
	);
};

export default SegmentedToggle;
